export const MetasurveyLogoSvg = {
  template: `
		<svg
        width="1em"
        height="1em"
        viewBox="0 0 512 512"
        xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="ArtboardFrame">
        <rect
            height="512"
            width="512"
            x="0"
            y="0"
        />
      </clipPath>
      <g clip-path="url(#ArtboardFrame)">
        <path
            d="M179.56 64.5196C179.56 38.7968 200.413 17.9443 226.136 17.9443L425.506 17.9443C451.229 17.9443 472.081 38.7968 472.081 64.5196L472.081 356.234C472.081 381.956 451.229 402.809 425.506 402.809L226.136 402.809C200.413 402.809 179.56 381.956 179.56 356.234L179.56 64.5196Z"
            fill="none"
            opacity="1"
            stroke="#00ccff"
            stroke-linecap="butt"
            stroke-linejoin="round"
            stroke-width="29.1096"
        />
        <path
            d="M299.401 446.173L391.935 446.254C383.975 453.137 372.592 456.823 372.592 456.823L176.859 508.938C144.089 517.663 110.449 498.178 101.714 465.411L26.7804 184.345C18.0452 151.581 37.5163 117.937 70.277 109.188L136.287 91.5584L136.206 121.551L77.1368 137.568C60.2322 142.152 50.2194 159.545 54.7444 176.466L130.113 458.293C134.681 475.377 152.234 485.523 169.318 480.955L299.401 446.173Z"
            fill="#ff3399"
            fill-rule="nonzero"
            opacity="1"
            stroke="none"
        />
      </g>
    </svg>
	`
};

export const Smile5 = {
  template: `
  <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M24 0C10.8 0 0 10.8 0 24C0 37.2 10.8 48 24 48C37.2 48 48 37.2 48 24C48 10.8 37.2 0 24 0ZM14 19C14 17.3431 15.343 16 17 16C18.657 16 20 17.3431 20 19C20 20.6569 18.657 22 17 22C15.343 22 14 20.6569 14 19ZM24 34C21.016 34 18.218 32.952 16.04 31.0012C15.444 30.4674 15.406 29.94 15.374 29.7405C15.236 28.8745 15.83 27.687 17.074 27.5099C17.683 27.4231 18.295 27.6316 18.697 27.9865C20.148 29.2649 22.043 30 24 30C25.936 30 27.812 29.2803 29.257 28.0266C31.388 26.2403 33.854 29.1446 32.001 30.9643C29.817 32.9388 27.002 34 24 34ZM34 19C34 20.6569 32.657 22 31 22C29.343 22 28 20.6569 28 19C28 17.3431 29.343 16 31 16C32.657 16 34 17.3431 34 19Z" />
  </svg>
	`
};

export const Smile4 = {
  template: `
	<svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M24 0C10.8 0 0 10.8 0 24C0 37.2 10.8 48 24 48C37.2 48 48 37.2 48 24C48 10.8 37.2 0 24 0ZM14 19C14 17.3431 15.343 16 17 16C18.657 16 20 17.3431 20 19C20 20.6569 18.657 22 17 22C15.343 22 14 20.6569 14 19ZM27.9 32.3C25.7 33.4 23.2 34 20.7 34H17.957H17.949C16.873 34 16 33.1274 16 32.051V31.949C16 30.8726 16.873 30 17.949 30H17.966H20.7C22.6 30 24.4 29.6 26.1 28.7L29.293 27.1037L29.308 27.096C30.298 26.6012 31.501 27.0023 31.996 27.992L32.004 28.008C32.499 28.9977 32.098 30.2012 31.108 30.696L27.9 32.3ZM34 19C34 20.6569 32.657 22 31 22C29.343 22 28 20.6569 28 19C28 17.3431 29.343 16 31 16C32.657 16 34 17.3431 34 19Z" />
  </svg>
	`
};

export const Smile3 = {
  template: `
	<svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M24 0C10.8 0 0 10.8 0 24C0 37.2 10.8 48 24 48C37.2 48 48 37.2 48 24C48 10.8 37.2 0 24 0ZM14 19C14 17.3431 15.343 16 17 16C18.657 16 20 17.3431 20 19C20 20.6569 18.657 22 17 22C15.343 22 14 20.6569 14 19ZM32 30C32 31.1046 31.105 32 30 32H18C16.895 32 16 31.1046 16 30C16 28.8954 16.895 28 18 28H30C31.105 28 32 28.8954 32 30ZM34 19C34 20.6569 32.657 22 31 22C29.343 22 28 20.6569 28 19C28 17.3431 29.343 16 31 16C32.657 16 34 17.3431 34 19Z" />
  </svg>
	`
};

export const Smile2 = {
  template: `
	<svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M24 0C10.8 0 0 10.8 0 24C0 37.2 10.8 48 24 48C37.2 48 48 37.2 48 24C48 10.8 37.2 0 24 0ZM14 19C14 17.3431 15.3431 16 17 16C18.6569 16 20 17.3431 20 19C20 20.6569 18.6569 22 17 22C15.3431 22 14 20.6569 14 19ZM18.4412 33.4147C17.3672 33.6832 16.278 33.0341 16.003 31.9617C15.7257 30.8802 16.3816 29.7796 17.4647 29.5088L29.5588 26.4853C30.6328 26.2168 31.722 26.8659 31.997 27.9383C32.2743 29.0198 31.6184 30.1204 30.5353 30.3912L18.4412 33.4147ZM34 19C34 20.6569 32.6569 22 31 22C29.3431 22 28 20.6569 28 19C28 17.3431 29.3431 16 31 16C32.6569 16 34 17.3431 34 19Z" />
  </svg>
	`
};

export const Smile1 = {
  template: `
		<svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 0C10.8 0 0 10.8 0 24C0 37.2 10.8 48 24 48C37.2 48 48 37.2 48 24C48 10.8 37.2 0 24 0ZM14 19C14 17.3431 15.3431 16 17 16C18.6569 16 20 17.3431 20 19C20 20.6569 18.6569 22 17 22C15.3431 22 14 20.6569 14 19ZM31.1754 32.4329C30.431 32.65 29.7246 32.3891 29.3339 32.0412C27.8794 30.7457 25.9707 30 24 30C22.0744 30 20.2081 30.712 18.7667 31.9531C18.3367 32.3232 16.9566 33.0499 15.8963 31.8608C14.9423 30.7909 15.4665 29.5419 16.0769 29.0057C18.2496 27.0971 21.0334 26 24 26C26.9961 26 29.8057 27.0568 31.9877 29.0234C32.5732 29.5511 32.6319 30.153 32.6448 30.5351C32.6649 31.1314 32.2417 32.1219 31.1754 32.4329ZM34 19C34 20.6569 32.6569 22 31 22C29.3431 22 28 20.6569 28 19C28 17.3431 29.3431 16 31 16C32.6569 16 34 17.3431 34 19Z" />
    </svg>
	`
};
